import { toItem } from '../mappers/item';
import { getParameterByName, partial } from '../../../utils/utils';
export function parseItems(settings, res) {
  let cursor = null;
  let size = null;
  if (res.data.paging && res.data.paging.cursors && res.data.paging.cursors.after && res.data.paging.next) {
    cursor = res.data.paging.cursors.after;
    size = Number(getParameterByName(res.data.paging.next, 'limit'));
  }
  res.data = (res.data.data || []).map(partial(toItem, settings));
  res.paging = {
    cursor,
    size
  };
  return res;
}